// libraries
import React, { useState, useEffect } from "react";

// styles
import styles from "./styles.module.scss";

// components
import FirstReview from "./FirstReview/FirstReview";
import ReviewListModal from "./ReviewListModal/ReviewListModal";
import ReviewInfo from "./ReviewInfo";
import Item from "./Item";

// api
import { getReviews } from "../api";

const Reviews = ({ data, setData }) => {
  // states
  const [reviewModal, setReviewModal] = useState(false);
  const [list, setList] = useState([]);

  const [reFetch, setReFetch] = useState(false);

  useEffect(() => {
    if (data) {
      fetchReviews();
    }
  }, [data]);

  useEffect(() => {
    if (reFetch) {
      fetchReviews();
    }
  }, [reFetch]);

  const fetchReviews = () => {
    let props = {
      eventId: +data.EventId,
    };

    getReviews(props)
      .then((res) => {
        if (res.data.Status) {
          const { Results } = res.data;
          console.log("review", Results);
          setList(Results?.reviewDescriptionWithModel || []);

          if (reFetch) {
            setReFetch(false);
            setData({
              ...data,
              ratings: Results?.eventRatingDetailsModel?.AverageRating || "0",
              ratingCount: Results?.eventRatingDetailsModel?.TotalVotes || "0",
            });
          }
        } else {
          console.log(res.data.ErrorMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className={styles.reviews}>
      {list.length > 0 ? (
        <ReviewInfo data={data} setReFetch={setReFetch} />
      ) : (
        <FirstReview data={data} setReFetch={setReFetch} />
      )}
      {list.length > 0 && (
        <>
          <Item data={list[0]} />
          {list.length >= 1 && (
            <button onClick={() => setReviewModal(true)}>
              View All Reviews
            </button>
          )}
          {reviewModal && (
            <ReviewListModal
              list={list}
              closeModal={() => setReviewModal(false)}
            />
          )}
        </>
      )}
    </div>
  );
};

export default Reviews;
